import { render } from "./AddOption.vue?vue&type=template&id=a10fa816&scoped=true"
import script from "./AddOption.vue?vue&type=script&lang=js"
export * from "./AddOption.vue?vue&type=script&lang=js"

import "./AddOption.vue?vue&type=style&index=0&id=a10fa816&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a10fa816"]])

export default __exports__